import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SurveyQuestionInterface, SurveyTranslateQuestionInterface } from '@families-link/shared';
import { CoreModal } from '../../../_core/components/_ui/core-modal';
import { SurveyQuestionRender } from '../question/question.component';

export interface SurveyModalProps {
	modalTitle: string;
	questions: SurveyQuestionInterface[];
	language: any;
	open: boolean;
	onClose: () => void;
}

export const SurveyModal: React.FC<SurveyModalProps> = ({ modalTitle, questions, language, open, onClose }) => {
	const { t } = useTranslation();

	return (
		<CoreModal modalTitle={modalTitle} open={open} onClose={onClose}>
			<Box>
				{questions?.map((question, index) => (
					<Box key={question.text} sx={{ p: 1, display: 'flex', flexDirection: 'column' }}>
						<SurveyQuestionRender
							question={question}
							customLabel={`${index + 1}. ${question.translatedText ? question.translatedText : question.text}`}
						/>
					</Box>
				))}
			</Box>
		</CoreModal>
	);
};
